export default __webpack_public_path__ + "images/oHRLogo.ab9a043aa7da72dc38c531f970ed21c7.svg";